import { PROFILES_GATE_POPUP_ID } from '../popups/popups.constants';

export const SHOW_SCREENSAVER_SIGNAL = 'show';

export const HIDE_SCREENSAVER_SIGNAL = 'hide';

export const SCREEN_SAVER_COUNTDOWN = 120000;

export const ITERATION_TOTAL_DURATION = 8;

export const SCREEN_APPEAR_DURATION = 0.15;

export const LOGO_APPEAR_DURATION = 1;

// LABEL_SWAP_DURATION_OFFSET cannot be higher than ITERATION_TOTAL_DURATION
export const LABEL_SWAP_DURATION_OFFSET = 6.5;

export const LABEL_APPEAR_DURATION = 3;

export const LABEL_APPEAR_DELAY = 0.5;

export const LABEL_FADE_IN_DURATION = 3.5;

export const LABEL_FADE_OUT_DURATION = 1;

// BACKGROUND_DURATION cannot be higher than ITERATION_TOTAL_DURATION
export const BACKGROUND_DURATION = 6.9;

export const BACKGROUND_FADE_IN_DURATION = 2;

export const BACKGROUND_FADE_OUT_FAST = 1;

export const BACKGROUND_FADE_OUT_SLOW = 2;

export const BACKGROUND_FADE_DELAY = 0.5;

export const BACKGROUND_IDLE_SUSTAIN = 2;

export const FADE_IN = 0;

export const FADE_OUT = 1;

export const BANNED_POPUPS = [PROFILES_GATE_POPUP_ID];

export const BANNED_WIDGETS = ['CookieConsent'];
